/**
 * Line chart. One trace per `series[]`, or a single trace from `encoding.yKey`.
 */

import type { ChartTypeDefinition, ChartTrace } from '../types';
import { registerChart } from '../registry';
import { makeSeriesTraces } from '../shared/traces';
import { xColumn } from '../shared/encoding';
import { figureScale } from '../theme/scale';
import { SERIES_LINE_WIDTH } from '../theme/layout';
import { colorAt } from '../theme/palette';

export const lineChart: ChartTypeDefinition = {
  id: 'line',
  label: 'Line',
  capabilities: {
    multiSeries: true,
    supportsXKey: true,
    supportsYKey: true,
    supportsGroupBy: false,
    supportsLimits: true,
    filterable: true,
    supportsStacked: false,
    legendByDefault: true,
    supportsSecondaryYAxis: true,
    supportsLineStyle: true,
  },
  buildTraces(model, ctx) {
    const { data, encoding, series, labels, options } = model;
    const scale = figureScale(ctx.figureWidth);

    if (series.length > 0) {
      return makeSeriesTraces(
        data,
        xColumn(data, encoding.xKey),
        series,
        ctx.palette,
        'line',
        false,
        scale,
        options?.markerSize,
        options?.smoothMonotone
      );
    }
    if (encoding.yKey) {
      const trace: ChartTrace = {
        x: xColumn(data, encoding.xKey),
        y: data.map((d) => d[encoding.yKey as string]),
        name: labels.title ?? 'value',
        type: 'scatter',
        mode: 'lines',
        line: { color: colorAt(0, ctx.palette), width: SERIES_LINE_WIDTH * scale },
      };
      return [trace];
    }
    return [];
  },
};

registerChart(lineChart);
